import React from 'react';
import TrashedUserActions from './trashed-user-actions';
import FormattedDate from 'components/formatted-date';
import {ColumnDef} from '@tanstack/table-core';
import {Trans} from 'react-i18next';
import {User} from 'types/user';

const columns: ColumnDef<User>[] = [
  {
    header: () => <Trans i18nKey="usersPage.avatar" />,
    accessorFn: r => (
      <img
        src={r.profile?.avatar?.square}
        className="user-avatar rounded rounded-5"
      />
    ),
    cell: r => r.getValue(),
    meta: {
      cellCostumClass: 'ps-4',
      costumClass: 'text-center ps-2',
    },
    enableSorting: false,
    id: 'id',
  },
  {
    header: () => <Trans i18nKey="usersPage.fullName" />,
    cell: row => row.getValue(),
    accessorFn: row => row.profile?.full_name,
    id: 'full_name',
    enableSorting: true,
  },
  {
    header: () => <Trans i18nKey="usersPage.role" />,
    accessorFn: row => row.role?.label,
    cell: row => row.getValue(),
    id: 'role',
    enableSorting: false,
  },
  {
    header: () => <Trans i18nKey="usersPage.email" />,
    accessorFn: row => <a href={`mailto:${row.email}`}>{row.email}</a>,
    cell: row => row.getValue(),
    id: 'email',
    enableSorting: true,
  },
  {
    header: () => <Trans i18nKey="usersPage.deletedAt" />,
    accessorFn: row => <FormattedDate value={row.deleted_at} format="datetime" />,
    cell: row => row.getValue(),
    id: 'deleted_at',
    enableSorting: true,
  },
  {
    header: () => <Trans i18nKey="usersPage.action" />,
    enableSorting: false,
    accessorFn: row => <TrashedUserActions user={row} />,
    cell: row => row.getValue(),
    id: 'action',
  },
];

export default columns;